import jwtAuthAxios from "../../services/jwtAuth";
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const ENDPOINT = 'v1/master/periode_pendaftaran';

export const getPeriodePendaftaran = createAsyncThunk("periode-pendaftaran/getAll", async() => {
    try{
        let token = await localStorage.getItem('auth_token');
        jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        const response = await jwtAuthAxios.get(`${ENDPOINT}`)
        return response.data
    } catch(response){
        throw response
    }
});

export const getByIdPeriodePendaftaran = createAsyncThunk("periode-pendaftaran/getById", async(id) => {
    try{
        let token = await localStorage.getItem('auth_token');
        jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        const response = await jwtAuthAxios.get(`${ENDPOINT}/${id}`)
        return response.data
    } catch(response){
        throw response
    }
});

export const savePeriodePendaftaran = createAsyncThunk("periode-pendaftaran/save", async(payload) => {
    try{
        let token = await localStorage.getItem('auth_token');
        jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        const response = await jwtAuthAxios.post(`${ENDPOINT}`, payload)
        return response.data
    } catch(response){
        throw response
    }
});

export const updatePeriodePendaftaran = createAsyncThunk("periode-pendaftaran/update", async(payload) => {
    try{
        let token = await localStorage.getItem('auth_token');
        jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        const response = await jwtAuthAxios.put(`${ENDPOINT}`, payload)
        return response.data
    } catch(response){
        throw response
    }
});

export const deletePeriodePendaftaran = createAsyncThunk("periode-pendaftaran/delete", async(id) => {
    try{
        let token = await localStorage.getItem('auth_token');
        jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        const response = await jwtAuthAxios.delete(`${ENDPOINT}/${id}`)
        return response.data
    } catch(response){
        throw response
    }
});

// Set periode terpilih jadi aktif (S-01), sisanya kadaluarsa (S-03), sinkron t_periode
export const setAktifPeriodePendaftaran = createAsyncThunk("periode-pendaftaran/setAktif", async(id) => {
    try{
        let token = await localStorage.getItem('auth_token');
        jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        const response = await jwtAuthAxios.put(`${ENDPOINT}/set-aktif/${id}`)
        return response.data
    } catch(response){
        throw response
    }
});

const initialState = {
    loading: false,
    dataPeriodePendaftaran: [],
}

const periodePendaftaranSlice = createSlice({
    name:"periodePendaftaran",
    initialState: initialState,
    extraReducers: (builder) => {
    builder
        .addCase(getPeriodePendaftaran.pending, (state) => {
            state.loading = true;
        })
        .addCase(getPeriodePendaftaran.fulfilled, (state, action) => {
            state.dataPeriodePendaftaran = action.payload;
            state.loading = false;
        })
        .addCase(getPeriodePendaftaran.rejected, (state) => {
            state.loading = false;
        })
    builder
        .addCase(savePeriodePendaftaran.pending, (state) => {
            state.loading = true;
        })
        .addCase(savePeriodePendaftaran.fulfilled, (state) => {
            state.loading = false;
        })
        .addCase(savePeriodePendaftaran.rejected, (state) => {
            state.loading = false;
        })
    builder
        .addCase(updatePeriodePendaftaran.pending, (state) => {
            state.loading = true;
        })
        .addCase(updatePeriodePendaftaran.fulfilled, (state) => {
            state.loading = false;
        })
        .addCase(updatePeriodePendaftaran.rejected, (state) => {
            state.loading = false;
        })
    builder
        .addCase(deletePeriodePendaftaran.pending, (state) => {
            state.loading = true;
        })
        .addCase(deletePeriodePendaftaran.fulfilled, (state) => {
            state.loading = false;
        })
        .addCase(deletePeriodePendaftaran.rejected, (state) => {
            state.loading = false;
        })
    }
})
export const periodePendaftaranSelector = (state) => state.periodePendaftaran;
export default periodePendaftaranSlice.reducer;
